module.exports = ({ cssCode, htmlCode, jsCode }) => `
   <!DOCTYPE html lang="en">
      <meta charset="UTF-8">
      <head>
         <link rel="stylesheet" href="https://ds.fusioncharts.com/2.0.6/css/ds.css">
         <script src="https://cdn.fusioncharts.com/fusioncharts/3.19.0/fusioncharts.js"></script>
         <script src="https://cdn.fusioncharts.com/fusioncharts/3.19.0/themes/fusioncharts.theme.fusion.js"></script>
         <style>
            /* the embedding page sizes this frame to the content, so the sample never scrolls.
               A scrollbar would only appear when the content is a pixel taller than the frame;
               it narrows the page, makes a 100%-wide chart redraw, and the redraw changes the
               height again - the chart then visibly flickers. */
            html, body { overflow: hidden; }
         </style>
         <style> ${cssCode} </style>
      </head>
      <body > ${htmlCode} </body>
      <script type="text/javascript">${jsCode}</script>
      <script type="text/javascript">
         // Tell the embedding page how tall this sample really is (it changes when a button
         // renders a chart or a drill-down opens), so its frame never leaves blank space.
         (function () {
            var MIN_HEIGHT = 180; // keep the spot where a chart will draw visible, see below
            var last = 0;
            var timer = null;

            function measure() {
               // measure the content's bottom edge, not the page height: this page renders in
               // quirks mode, where html/body always stretch to fill the frame
               var bottom = 0;
               for (var i = 0; i < document.body.children.length; i += 1) {
                  var r = document.body.children[i].getBoundingClientRect();
                  if (r.height > 0 && r.bottom > bottom) bottom = r.bottom;
               }
               var h = Math.ceil(
                  bottom + (window.pageYOffset || 0) + parseFloat(getComputedStyle(document.body).marginBottom || 0)
               );
               // FusionCharts will not draw into a container that is outside the visible frame, so a
               // sample whose chart appears later (e.g. after a button click) must never be shrunk
               // to exactly its button row - the chart would wait forever and the frame never grow.
               return Math.max(h, MIN_HEIGHT);
            }

            function report() {
               timer = null;
               var h = measure();
               if (Math.abs(h - last) > 1) {
                  last = h;
                  parent.postMessage({ fcEmbedHeight: h }, '*');
               }
            }

            // Never resize the frame while a chart is still loading its data or drawing - a
            // resize mid-load makes FusionCharts show "No data to display". Wait until the chart
            // says its data plots are drawn (drawComplete - renderComplete also fires for the
            // "retrieving data" placeholder, too early), or the content has been still a while.
            function schedule(delay) {
               clearTimeout(timer);
               timer = setTimeout(report, delay);
            }

            window.addEventListener('load', function () { schedule(1500); });
            if (window.FusionCharts && FusionCharts.addEventListener) {
               FusionCharts.addEventListener('drawComplete', function () { schedule(150); });
            }
            // notice content changes (a button rendering a chart, a drill-down opening)
            setInterval(function () {
               if (!timer && Math.abs(measure() - last) > 1) schedule(1500);
            }, 500);
         })();
      </script>
   </DOCTYPE>`;
